// @ts-nocheck
import GridItem from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import SearchButtonClearFilter from "@store/Library/Components/Reporting/Common/SearchButtonClearFilter";
import SearchButtonSubmitFilter from "@store/Library/Components/Reporting/Common/SearchButtonSubmitFilter";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    isLoading: boolean;
    updateData: () => Promise<void>;
    onClear: () => void;
    children?: React.ReactNode;
}

const ApiButtons: React.FC<Props> = ({ onClear, isLoading, updateData, children }) => {
    return (
        <LoadingOverlay
            css={css`
                @media (min-width: 767px) {
                    max-height: 73px;
                }
            `}
            loading={isLoading}
        >
            <GridItem
                align="top"
                width={[12, 6, 12, 6, 6]}
                css={css`
                    gap: 2rem;

                    flex-wrap: wrap;
                `}
            >
                <SearchButtonSubmitFilter handleSubmit={updateData} isLoading={isLoading} />
                <SearchButtonClearFilter onClear={onClear} />
                {children}
            </GridItem>
        </LoadingOverlay>
    );
};

export default ApiButtons;
